import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Configuration } from 'app/models/configuration/configuration';
import { SimpleProduct } from 'app/models/product/product/simple-product';
import { ConfigurationService } from 'app/services/configurations/configurations.service';
import { ParameterService } from 'app/services/parameter/parameter.service';
import { ProductService } from 'app/services/product/product.service';
import { StringCleanUtils } from 'app/shared/string-clean.utils';
import { SelectItem } from 'primeng/api';
import { CartService } from '../../services/cart/cart.service';
import { SiteSettings } from '../settings/settings-page/site-settings';
import { CategoryService } from '../../services/category/category.service';
import { NbToastrService } from '@nebular/theme';


@Component({
  selector: 'ultra-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit {

  featuredCategory: { id: number, name: String } = { id: null, name: null };
  offer: { id: number, name: String } = { id: -99, name: 'Ofertas' };
  pagedOfferProducts: SimpleProduct[] = [];
  offerPanel: string;
  styleConfig = { backgroundColor: '#00569a', color: '#ffffff', barColor: '#00569a', endBarColor: '#f9ed69' };
  products: SimpleProduct[] = [];
  filteredProducts: [];
  totalSize: number;
  totalOfferSize: number;
  pagedProducts: SimpleProduct[] = [];
  sortOptions: SelectItem[];
  categoryList: any[] = [];
  sortOrder: number = 2;
  pageSize: number = 24;
  carousel: any;
  startRows: number = 0;
  currentPage: number = 1;
  currentOfferPage: number = 1;
  siteSettings = SiteSettings.getInstance();
  firstLoadingFeaturedProducts: boolean = true;
  firsttLoadingOfferProducts: boolean = true;

  constructor(
    private router: Router,
    private cartService: CartService,
    private _parametersService: ParameterService,
    private _productService: ProductService,
    private service: ConfigurationService,
    private categoryService: CategoryService,
    private _settingsService: ConfigurationService,
    private _toastrService: NbToastrService
  ) {
  }

  ngOnInit() {
    this.ckeckStyle();

    this._settingsService.getConfigurations().subscribe((value: any) => {
      let categories = value?.data?.featured_category ?? [];

      const accessToken = sessionStorage.getItem('defaultCategories') ?? '';

      if (accessToken != '') {
        if (categories.length > 0) {
          value.data.featured_category = []
          this._settingsService.saveConfiguratios(value.data).subscribe();
        }

        categories = accessToken.split(',').map(e => Number(e));
      }

      this.offerPanel = value?.data?.displayOffer;
      if (categories?.length > 0) {
        this.categoryService.customList(`?categories=${categories.join(',')}`).subscribe((canShow: any) => {
          this.categoryList = canShow.data.map(e => { return { id: e.ID, name: e.DESCRIPTION } });
          if (value.data.offer == true)
            this.categoryList.splice((this.categoryList.length - 1), 0, { id: -99, name: 'OFERTAS' });
        })
      }
      else {
        if (value.data.offer == true)
          this.categoryList.splice((this.categoryList.length - 1), 0, { id: -99, name: 'OFERTAS' });
      }
      this.loadData();
      this.loadOfferData(1, this.offerPanel !== 'NOT');
    })
    //this.createCarrousel();
  }

  loadData(page?: number) {
    this._productService.getFeaturedProducts((page ?? 1), this.sortOrder).subscribe((value: any) => {
      if (value && value.data != null && value.data[0] != null) {
        this.pagedProducts = value.data[0].products.map((e) => SimpleProduct.fromJson(e));
        this.featuredCategory.name = value.data[0].DESCRIPTION;
        this.featuredCategory.id = value.data[0].ID;
        this.totalSize = value.message;
        this.firstLoadingFeaturedProducts = false;
      }
    }, (error) => {
      this._toastrService.danger('Falha ao buscar listagem de produtos em destaque', 'Erro');
      this.firstLoadingFeaturedProducts = false;
    })
  }

  loadOfferData(page?: number, isVisible: boolean = false) {
    if (isVisible) {
      this._productService.getOffers((page ?? 1), this.sortOrder).subscribe((value: any) => {
        if (value && value.data != null && value.data[0] != null) {
          this.pagedOfferProducts = value.data.map((e) => SimpleProduct.fromJson(e));
          this.totalOfferSize = value.message;
        }
        this.firsttLoadingOfferProducts = false;
      }, (error) => {
        this._toastrService.danger('Falha ao buscar listagem de produtos em oferta', 'Erro');
        this.firsttLoadingOfferProducts = false;
      })
    }
  }

  ckeckStyle() {
    let config = this.siteSettings.getConfiguration();

    if (config != null && config != undefined) {
      this.setStyleConfig(config);
    } else {
      this._loadConfigServer();
    }
  }

  _loadConfigServer(): void {
    this.service.getConfigurations().subscribe((value) => {
      this.siteSettings.setConfiguration(Configuration.fromJson(value.data));
      this.ckeckStyle();
    });
  }

  goToCategory(categoryId: String): void {
    this.router.navigate(['pages/products'],
      { queryParams: { category: categoryId } });
  }

  setStyleConfig(config: Configuration) {

    if (config.background.length > 0) {
      this.styleConfig.backgroundColor = config.background;
    }
    if (config.color.length > 0) {
      this.styleConfig.color = config.color;
    }
    if (config.shortcutBarColor.length > 0) {
      this.styleConfig.barColor = config.shortcutBarColor;
    }
    if (config.shortcutBarColorEnd.length > 0) {
      this.styleConfig.endBarColor = config.shortcutBarColorEnd;
    }

    this.createCarrousel(config);
  }

  createCarrousel(configColors: any) {

    this.carousel = configColors.carrousel;

  }

  goToUrl(url) {
    if (url.indexOf('category/') != -1) {
      const categoria = url.substring(url.indexOf('/') + 1, url.length);
      this.router.navigate(['pages/products'], { queryParams: { category: categoria } });
      return;
    }

    if (url.substring(0, 3) == 'www') {
      url = 'http://' + url;
    }

    this.router.navigate([]).then(result => { window.open(url, '_blank'); });
  }

  displayCarousel() {
    return (this.siteSettings.configuration?.displayCarousel ?? true) && (this.siteSettings.configuration?.carrousel?.length > 0);
  }

  createSortOptions() {
    this.sortOptions = [
      { label: 'Preço Crescente', value: 'price' },
      { label: 'Preço Decrescente', value: '!price' },
      { label: 'Alfabética A-Z', value: 'name' },
      { label: 'Alfabética Z-A', value: '!name' },
    ];
  }

  // pageEvent(event) {
  //   this.lazyLoadProduct(this.filteredProducts, event);
  // }
  sortEvent(order, isOffer: boolean = false) {
    this.sortOrder = order;

    isOffer == false ? this.loadData(this.currentPage) : this.loadOfferData(this.currentOfferPage, true);
  }

  pageEvent(event, isOffer: boolean = false) {
    if (!isOffer) {
      this.currentPage = (event.first + event.rows) / this.pageSize;
      this.loadData(this.currentPage);
    } else {
      this.currentOfferPage = (event.first + event.rows) / this.pageSize;
      this.loadOfferData(this.currentOfferPage, true);
    }
    // this.screenConfig.currentFirst = event.first;
    // this.lazyLoadProduct(this.filteredProducts, event);
  }

  lazyLoadProduct(list: any, event: any) {
    if (list?.length > 0) {
      const start = event.first;
      const end = start + event.rows;
      if (list.length > (end - start)) {
        list = list.slice(start, end);
      }
      this.pagedProducts = list;
    } else {
      this.pagedProducts = [];
    }
  }

  clean(word: String): string {
    return StringCleanUtils.replaceSpecialChars(word);
  }

}
